import { actionPageTypes, ActionTypes, IInitialState } from './reducer.type';

export const initialState: IInitialState = {
  banners: [],
  loading: true,
  selectedBanner: null,
  choosenModal: null,
};

export const reducer = (
  state = initialState,
  action: ActionTypes,
): IInitialState => {
  switch (action.type) {
    case actionPageTypes.SET_BANNERS:
      return { ...state, banners: action.payload };
    case actionPageTypes.SET_LOADING:
      return { ...state, loading: action.payload };
    case actionPageTypes.SET_CHOOSEN_MODAL:
      return { ...state, choosenModal: action.payload };
    case actionPageTypes.SET_SELECTED_BANNER:
      return { ...state, selectedBanner: action.payload };
    default:
      return state;
  }
};
